<div class="max-w-6xl mx-auto">
    <div class="bg-white shadow rounded-lg p-6 mb-8 text-center">
        <h1 class="text-3xl font-bold mb-2">Modifier la prédiction</h1>
    </div>
    <div class="bg-white shadow rounded-lg p-8">

        <app-formations-form [initialData]="formations()" (formSubmit)="onEdit($event)" [isEditMode]="true" ></app-formations-form>
    </div>

</div>
